import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Badge, Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import { buscarDispositivos, buscarNotificacoes } from "../../store/auth/profile/actions"
import moment from "moment"
import Loader from "react-loader-spinner"
import { MDBDataTable } from "mdbreact"
import DispositivoLogsModal from "pages/CardapioDigital/dispositivo-logs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import { getCompaniesValuesByOptions } from "../../helpers/utils"
import toastr from "toastr"
import { apiBuscarNotificacoes } from "../../helpers/backend_helper"
import { withTranslation } from "react-i18next"

const CardapioDispositivosLista = props => {
  const [dataDispositivos, setDataDispositivos] = useState({
    columns: [
      { label: "Registro", field: "Registro", sort: "asc", width: 150 },
      { label: "Empresa", field: "Empresa", sort: "asc", width: 150 },
      {
        label: "Data inclusão",
        field: "Data inclusão",
        sort: "asc",
        width: 270
      },
      {
        label: "Data última atualização",
        field: "Data última atualização",
        sort: "asc",
        width: 270
      },
      {
        label: "ID do dispositivo Android",
        field: "ID do dispositivo Android",
        sort: "asc",
        width: 200
      },
      {
        label: "Versão Android",
        field: "Versão Android",
        sort: "asc",
        width: 150
      },
      { label: "Versão APP", field: "Versão APP", sort: "asc", width: 100 },
      { label: "Bateria", field: "Bateria", sort: "disabled", width: 100 },
      {
        label: "Visualizar Logs",
        field: "Visualizar Logs",
        sort: "disabled",
        width: 150
      }
    ],
    rows: []
  })
  const [notificacoesBaixaBateria, setNotificacoesBaixaBateria] = useState([])

  useEffect(() => {
    let companies = [];
    if(props.dashboardFilters.companiesSelected) {
      companies = getCompaniesValuesByOptions(props.dashboardFilters.companiesSelected)
    }
    props.buscarDispositivos({ companies: companies })
    props.navegarBreadCrumb({title: `breadcrumb.menu.devices`, link: location.pathname})

    const params = {}
    const filters = []
    filters.push({id: 'notifica_baixa_bateria', value: true})
    if (companies.length > 0) {
      filters.push({id: 'idEmpresa', value: companies})
    } else {
      filters.push({ id: 'semEmpresa', value: true })
    }
    const projection = ["percentual_bateria_minima"]
    params['filters'] = JSON.stringify(filters)
    params['projection'] = JSON.stringify(projection)
    apiBuscarNotificacoes(params).then(result => {
      if (result.data) {
        setNotificacoesBaixaBateria(result.data)
      }
    }).catch(e => {
      console.error(e)
    })
  }, [])

  useEffect(() => {
    if (Array.isArray(props.dispositivos) && props.dispositivos.length > 0 && notificacoesBaixaBateria.length > 0) {
      const setBateriaMinima = new Set(
        notificacoesBaixaBateria.map(n => n.percentual_bateria_minima)
      )

      props.dispositivos.forEach((dispositivo) => {
        const bateria = dispositivo.percentual_bateria

        for (const percentualMinimo of setBateriaMinima) {
          if (bateria <= percentualMinimo) {
            toastr.warning(
              props.t('cardapio.dispositivo.lista.alerta.dispositivos', {
                porcentagem: percentualMinimo,
                id: dispositivo.id,
              })
            )
            break
          }
        }
      })
    }
  }, [props.dispositivos, notificacoesBaixaBateria])

  useEffect(() => {
    if(Array.isArray(props.dispositivos)) {
      const rows = props.dispositivos?.map(dispositivo => ({
          Registro: dispositivo.id,
          Empresa: dispositivo.empresa?.Fantasia,
          "Data inclusão": describeDateTime(dispositivo.created_at),
          "Data última atualização": describeDateTime(dispositivo.updated_at),
          "ID do dispositivo Android": dispositivo.imei,
          "Versão Android": dispositivo.versao_android,
          "Versão APP": dispositivo.versao_app,
          Bateria: (
            <Badge
              className={
                "font-size-12 badge-soft-" +
                describePercentualBaterial(dispositivo.percentual_bateria)
              }
              color={ describePercentualBaterial(dispositivo.percentual_bateria) }
              pill
            >
              { dispositivo.percentual_bateria }%
            </Badge>
          ),
          "Visualizar Logs": (
            <DispositivoLogsModal dispositivoId={ dispositivo.id } />
          )
        }))

      const isAdmin = props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador
      const columns = isAdmin ? dataDispositivos.columns : dataDispositivos.columns.filter(column => column.field !== "Empresa")

      setDataDispositivos({
        columns: columns,
        rows: rows
      })
    }
  }, [props.user, props.dispositivos])

  const describeDateTime = dateStr => {
    if (!dateStr) {
      return "N/D"
    }
    return moment(dateStr).format("DD/MM/YY HH:mm")
  }

  const describePercentualBaterial = percentual => {
    if (percentual > 50) {
      return "success"
    } else if (percentual <= 50 && percentual >= 20) {
      return "warning"
    } else {
      return "danger"
    }
  }

  return props.dispositivosLoading ? (
    <div className="loader-container">
      <Loader type="ThreeDots" color="#556EE6" height={ 80 } width={ 80 } />
    </div>
  ) : (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="breadcrumb.menu.devices" />
        <Row className="justify-content-center">
          <Col>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">{props.t('breadcrumb.menu.devices')}</CardTitle>
                <MDBDataTable
                  responsive
                  striped
                  bordered
                  data={ dataDispositivos }
                  entriesLabel={ "Mostrar Registros" }
                  infoLabel={ ["Exibindo", "a", "de", "registros"] }
                  noRecordsFoundLabel={ "Nenhum registro encontrado" }
                  paginationLabel={ ["Anterior", "Próximo"] }
                  searchLabel={ "Pesquisar" }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

CardapioDispositivosLista.propTypes = {
  dispositivos: PropTypes.array,
  dispositivosLoading: PropTypes.bool,
  buscarDispositivos: PropTypes.func
}

const mapStatetoProps = state => {
  const { dispositivos, dispositivosLoading } = state.Profile
  const { user, dashboardFilters} = state.Login
  return { dispositivos, dispositivosLoading, user, dashboardFilters }
}

export default withTranslation()(connect(mapStatetoProps, { buscarDispositivos, navegarBreadCrumb, buscarNotificacoes })(
  withRouter(CardapioDispositivosLista)
))
